module.exports = __webpack_public_path__ + "static/media/buildings.31e40b26.png";